import * as THREE from 'three';

/**
 * S10: moth ambience — PLAN-CITY §1.4's own "moth swarm as ambient stretch"
 * line. No Codex package has ever delivered a moth asset (none was briefed;
 * C03's Astoria enemy set is pigeon/dive-pigeon/trash-lobber/pizza-rat
 * only), so this is deliberately NOT a combat archetype — no AI, no
 * collision, no health, nothing `ai/archetypes.ts` or `EnemyManager` needs
 * to know about. Purely a handful of tiny emissive primitives drifting near
 * the utility tunnel's own dim interior (the one enclosed, unlit-feeling
 * space on the block — the natural "moths near a light" spot even without a
 * real day/night cycle to motivate it literally). Kept intentionally small:
 * a real winged/animated moth is a genuine future Codex ask, not something
 * to fake with primitives that would look wrong up close.
 */
const MOTH_COUNT = 6;
const CENTER = new THREE.Vector3(17, -1.2, 33);
const RADIUS = 1.6;
const DRIFT_SPEED = 0.9;
const BOB_SPEED = 1.6;
const BOB_HEIGHT = 0.35;

export class MothSwarm {
  readonly group = new THREE.Group();
  private readonly phases: number[] = [];

  constructor() {
    const geo = new THREE.SphereGeometry(0.035, 6, 6);
    const mat = new THREE.MeshStandardMaterial({ color: 0xd9d9a8, emissive: 0xc9c96a, emissiveIntensity: 1.2, roughness: 0.6 });
    for (let i = 0; i < MOTH_COUNT; i++) {
      const moth = new THREE.Mesh(geo, mat);
      this.group.add(moth);
      this.phases.push((i / MOTH_COUNT) * Math.PI * 2);
    }
    this.group.position.copy(CENTER);
  }

  update(dt: number): void {
    for (let i = 0; i < this.group.children.length; i++) {
      this.phases[i] += dt * DRIFT_SPEED * (0.7 + 0.3 * ((i % 3) / 2));
      const p = this.phases[i];
      const moth = this.group.children[i];
      moth.position.set(Math.cos(p) * RADIUS, Math.sin(p * BOB_SPEED) * BOB_HEIGHT, Math.sin(p) * RADIUS * 0.7);
    }
  }
}
